export default "__VITE_ASSET__a7802845__"